
import { PageRequest } from "@/store/shared/entity";
import {
  Component,
  Mixins,
  ActionButtonConfig,
  PageResultBaseMixins,
  PageResultListMixins,
  appConst,
  $util
} from "@/lib";

class PageIncomeRequest extends PageRequest {
  shippingNumber: string;
  customerId: number;
  businessGroup: string;
  shipmentDate: string[];
  status: string;
  constructor() {
    super();
    this.shipmentDate = $util.getSixMonthRange();
  }
}

@Component({ name: "income.list" })
export default class IncomeView extends Mixins(PageResultBaseMixins, PageResultListMixins) {
  buttons = { ...this.addBtn() };

  data: any = {
    model: new PageIncomeRequest(),
    queryAction: "foreignexchangecollection/income/getAll",
    isAutoQuery: true,
    cols: this.resultColumns,
  };

  //清除查询条件  重新加载数据
  reset() {
    this.data.model = new PageIncomeRequest();
  }

  //客户列表
  get customerList() {
    return this.$store.state.system.customer.customerList;
  }

  // 业务组列表
  get businessGroupList() {
    return this.getCodeListByCategory(appConst.codeCategory.businessGroup)
  }

  //状态
  get statusList() {
    return this.getCodeListByCategory(appConst.codeCategory.incomeStatus);
  }

  // 付款方式
  get paymentList() {
    return this.getCodeListByCategory(appConst.codeCategory.payment);
  }

  get resultColumns() {
    return [
      {
        title: this.L("app.DeclareCustoms.ShippingNumber"),
        key: "shippingNumber",
        minWidth: 120,
        maxWidth: 150,
      },
      {
        title: this.L("app.DeclareCustoms.CustomerName"),
        key: "customerName",
        minWidth: 250
      },
      this.$util.render.dateColumn("app.DeclareCustoms.ShipmentDate", "shipmentDate"),
      {
        title: this.L("app.DeclareCustoms.ReceiverAmount"),
        key: "receiverAmount",
        minWidth: 100,
        maxWidth: 150,
        render: (h: any, params: any) => {
          return [h("span", this.$util.format.amount(params.row.receiverAmount))];
        },
      },
      this.$util.render.codeColumn("app.DeclareCustoms.Payment", "payment", () => { return this.paymentList }, { width: 130 }),
      this.$util.render.codeColumn("app.DeclareCustoms.Status", "status", () => { return this.statusList }, { width: 100 }),
      this.$util.render.actions(this.colButtons, () => { return { fixed: "right" } })
    ];
  }

  get colButtons(): ActionButtonConfig[] {
    return [
      {
        label: "app.Income.Income",
        permission: "RIMS.Income.Income",
        check: row => {
          return row.isOwner && (row.status == appConst.incomeStatus.notExpired || row.status == appConst.incomeStatus.overdue || row.status == null);
        },
        callback: async (row: any) => {
          this.push("income.income", { declareCustomsId: row.declareCustomsId });
        }
      }
      ,
      {
        label: "app.Income.Unlock",
        permission: "RIMS.Income.Unlock",
        check: row => {
          return (row.customerConfirmStatus == appConst.confirmStatus.confirmed);
        },
        callback: async (row: any) => {
          await this.$store.dispatch("foreignexchangecollection/income/unlock", row)
          this.$store.dispatch("foreignexchangecollection/income/getAll", this.data);
        },
        needPoptip: true,
        popTipContent: this.L("app.Income.UnlockWarningText")
      }
      , this.colDetailBtnP(null, ["declareCustomsId"])];
  }

  async activated() {
    await this.$store.dispatch("system/customer/getCustomerList");
  }
}
